export const Push = {
  kindNames: new Map([
    ['parentStudentLinked', '연결 알림'],
    ['studentStatusChanged', '학생 상태 변경'],
    ['studentStudentLinked', '연결 알림'],
    ['dummy', '테스트 알림'],
    ['newBoardPost', '새 글 알림'],
    ['newNotePost', '새 알림장'],
    ['newComment', '댓글 알림'],
    ['newPostReviewRequest', '글 검토 요청'],
    ['billSent', '학원비 청구서'],
    ['billPaid', '학원비 결제'],
    ['wireTransferAck', '송금 수납 확인'],
    ['newChatMessage', '채팅 알림'],
    ['attendance', '출결 기록'],
    ['newHomework', '새 숙제'],
    ['remindHomework', '숙제 다시알림'],
    ['lessonRptPublished', '수업 리포트'],
    ['opsMsgChargeReport', '메시지 사용량 알림'],
    ['opsMsgQuotaAlert', '메시지 잔여 건수 알림'],
    ['opsMsgOutOfQuota', '메시지 발송 실패 알림'],
    ['opsBillAutoIssueRpt', '자동 청구서 발행 알림'],
  ]),
  receiverTypeNames: new Map([
    ['parent', '학부모'],
    ['subscriber', '구독자'],
    ['student', '학생'],
    ['teacher', '교사'],
    ['director', '원장'],
  ]),
  taskStateNames: new Map([
    ['creating', '생성중'],
    ['undone', '전송 대기'],
    ['inProgress', '전송중'],
    ['done', '전송 완료'],
  ]),
  itemStateNames: new Map([
    ['error', '실패'],
    ['notSent', '대기'],
    ['sent', '보냈음'],
    ['received', '도착함'],
    ['checkedWhileRunning', '확인함(실행중)'],
    ['checkedWhileOff', '확인함'],
  ]),
  osTypeNames: new Map([
    ['ios', 'iOS'],
    ['android', 'Android'],
    ['web', 'Web'],
  ]),
};

export function getPushKindLabel(kind: string) {
  return Push.kindNames.get(kind) || kind;
}

export function getPushReceiverTypeLabel(receiverType: string) {
  return Push.receiverTypeNames.get(receiverType) || receiverType;
}

export function getPushTaskStateLabel(taskState: string) {
  return Push.taskStateNames.get(taskState) || taskState;
}

export function getPushItemStateLabel(itemState: string) {
  return Push.itemStateNames.get(itemState) || itemState;
}

export function getPushOsTypeLabel(osType: string) {
  return Push.osTypeNames.get(osType) || osType;
}
